import { createContext } from 'react'

/**
 * Where a route placeholder is drawn. Outside the signed-in shell (login, public and guest pages)
 * it is `none`: those layouts own their look, and the organiser-shaped skeleton painted inside the
 * dark auth card was a shape swap of its own (sweep, 24.10.2026). Inside a layout that already
 * drew its frame (settings), `body` draws only the panel.
 */
export const RouteSkeletonScope = createContext<'none' | 'page' | 'body'>('none')

/** Whether `/event/:id` (the workspace, not its editor) opens on the overview: no tab, or «oversikt». */
export function eventRouteOpensOverview(search: string) {
  const tab = new URLSearchParams(search).get('t')
  return !tab || tab === 'oversikt'
}
